import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPlacementOfficer } from '@/redux/slice/placementOfficer.slice';
import { fetchStudentData } from '@/redux/slice/student.slice';
import { fetchHRInfo } from '@/redux/slice/humanResource.slice';

const HelperRoutes = () => {
  const { role, isAuth } = useSelector((state) => state.auth);

  const dispatch = useDispatch();

  useEffect(() => {
    if (isAuth) {
      if (role === 'PLACEMENT_OFFICER') {
        dispatch(fetchPlacementOfficer());
      }else if (role === 'HUMAN_RESOURCE') {
        dispatch(fetchHRInfo());
      } else if (role === 'STUDENT') {
        dispatch(fetchStudentData());
      }
    }
  }, [isAuth, role, dispatch]);

  return null;
};

export default HelperRoutes;
